module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-message"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.error,
      "subTitle": _vm.message
    }
  }), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.explanation) ? _c('div', {
    staticClass: "explanation"
  }, [_c('p', [_vm._v(_vm._s(_vm.explanationHTML))])]) : _vm._e(), (!_vm.explanation.length) ? _c('div', {
    staticClass: "default-explanation"
  }, [_c('p', [_vm._v("But don't panic, we are here to help...")]), _vm._m(0)]) : _vm._e()])]), (_vm.inAppLogin) ? _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickBackToApp.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Back to app")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If something has gone wrong and you're not sure why, just "), _c('a', {
    attrs: {
      "href": "https://www.teamwork.com/contact",
      "target": "_blank"
    }
  }, [_vm._v("drop us a quick note")]), _vm._v(" and we will do our best to help.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed0e5426","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/ErrorMessage/ErrorMessage.vue
// module id = 614
// module chunks = 1